import { render, staticRenderFns } from "./termsSettings.vue?vue&type=template&id=aff871b8&"
import script from "./termsSettings.vue?vue&type=script&lang=js&"
export * from "./termsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports